import React from 'react';
import styles from './MemberGuide.module.css';
import SubPageTop from '../components/SubPageTop';
import ScrollReveal from '../components/Ui/ScrollReveal';
import { FiUserPlus, FiCreditCard, FiCheckCircle } from "react-icons/fi";
import { FiAward, FiCalendar, FiGift } from "react-icons/fi";
import { Link } from 'react-router-dom';

const steps = [
    {
        icon: <FiUserPlus size={32} color="#ff5670" />,
        title: "회원가입 신청",
    },
    {
        icon: <FiCreditCard size={32} color="#ff5670" />,
        title: "회비납부",
    },
    {
        icon: <FiCheckCircle size={32} color="#ff5670" />,
        title: "가입완료",
    }
];

const benefits = [
    {
        icon: <FiAward size={36} color="#ff5670" />,
        number: "01",
        title: "교육 수강료 할인",
        description: "협회 정규 자격증 과정 및 컬러 교육 수강료 할인"
    },
    {
        icon: <FiCalendar size={36} color="#ff5670" />,
        number: "02",
        title: "행사 참여 기회",
        description: "컨퍼런스, 기부행사 등 협회 주관 행사 참여 기회 제공"
    },
    {
        icon: <FiGift size={36} color="#ff5670" />,
        number: "03",
        title: "세미나 할인 혜택",
        description: "가입 후 각종 세미나 할인 혜택"
    }
];
function MemberGuide() {
    return (
        <div className={styles.memberGuide}>
            <SubPageTop title="Member" subTitle="정회원 안내" backgroundColor="#74C5E9" />
            <div className={styles.memberGuideContent}>
                <ScrollReveal>
                    <div className={styles.section01}>
                    <h2 className={styles.title}>회원사 가입방법</h2>
                    <div className={styles.line}></div>
                    <div className={styles.steps}>
                        {steps.map((step, i) => (
                            <React.Fragment key={i}>
                                <div className={styles.step} key={i}>
                                    <div className={styles.iconWrap}>
                                        {step.icon}
                                    </div>
                                    <div className={styles.stepTitle}>{step.title}</div>
                                </div>
                                {i < steps.length - 1 && (
                                    <div className={styles.arrowWrap}>
                                        <img
                                            src="/image/arrow_right.png"
                                            alt="arrow_right"
                                            className={styles.arrow}
                                        />
                                    </div>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
                </ScrollReveal>
                <ScrollReveal>
                    <div className={styles.section02}>
                    <h2 className={styles.title}>회원사 가입비 및 연회비</h2>
                    <div className={styles.line}></div>
                    <div className={styles.tableWrap}>
                        <table className={styles.table}>
                            <thead>
                                <tr>
                                    <th>연회비</th>
                                    <th>납부 방법</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>5만 원</td>
                                    <td>
                                        <p>계좌 이체</p>
                                        <p>
                                            농협 079801-04-174326 (한국감성색채협회)
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                </ScrollReveal>
                <ScrollReveal>
                    <div className={styles.section03}>
                    <h2 className={styles.title}>정회원 혜택</h2>
                    <div className={styles.line}></div>
                    <div className={styles.benefitsGrid}>
                        {benefits.map((benefit, i) => (
                            <div className={styles.benefitCard} key={i}>
                                <div className={styles.benefitNumber}>{benefit.number}</div>
                                <div className={styles.benefitIconWrap}>
                                    {benefit.icon}
                                </div>
                                <h3 className={styles.benefitTitle}>{benefit.title}</h3>
                                <p className={styles.benefitDesc}>{benefit.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
                </ScrollReveal>
                <div className={styles.signupButtonWrap}>
                    <Link to="/signup" className={styles.signupButton}>
                        회원가입 신청
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default MemberGuide;